import { SenderDomainEffects } from './sender-domain.effects';
import { TemplateEffects } from './template.effects';

export const effects = [SenderDomainEffects, TemplateEffects];
